/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSpiderAggregatedEvent } from './CRSFSpiderAggregatedEvent';
import {
    CRSFSpiderAggregatedEventFromJSON,
    CRSFSpiderAggregatedEventFromJSONTyped,
    CRSFSpiderAggregatedEventToJSON,
} from './CRSFSpiderAggregatedEvent';

/**
 * 
 * @export
 * @interface CRSFSpidersAggregatedResponse
 */
export interface CRSFSpidersAggregatedResponse {
    /**
     * 
     * @type {Array<CRSFSpiderAggregatedEvent>}
     * @memberof CRSFSpidersAggregatedResponse
     */
    events?: Array<CRSFSpiderAggregatedEvent>;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSpidersAggregatedResponse
     */
    reported: boolean;
}

/**
 * Check if a given object implements the CRSFSpidersAggregatedResponse interface.
 */
export function instanceOfCRSFSpidersAggregatedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reported" in value;

    return isInstance;
}

export function CRSFSpidersAggregatedResponseFromJSON(json: any): CRSFSpidersAggregatedResponse {
    return CRSFSpidersAggregatedResponseFromJSONTyped(json, false);
}

export function CRSFSpidersAggregatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSpidersAggregatedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': !exists(json, 'events') ? undefined : ((json['events'] as Array<any>).map(CRSFSpiderAggregatedEventFromJSON)),
        'reported': json['reported'],
    };
}

export function CRSFSpidersAggregatedResponseToJSON(value?: CRSFSpidersAggregatedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': value.events === undefined ? undefined : ((value.events as Array<any>).map(CRSFSpiderAggregatedEventToJSON)),
        'reported': value.reported,
    };
}

